/***************************************************************************************
* @module Configuration
* @name config
* @description Application configuration settings for different environments
* @version 1.0.0
* @license Licensed under the MIT License
* @createdon May 2025
* @since 1.0
***************************************************************************************/

/* eslint-disable eqeqeq */
const CONFIG = {
}
const CURRENT_ENV = (process.env.ENV || process.env.env || 'LOCAL').toUpperCase();

const trimTrailingSlash = (value = '') => value.replace(/\/$/, '');
const socketUrlFromApiUrl = (apiUrl = '') => apiUrl.replace(/\/api\/v1\/?$/, '');
const LANDING_AUTH_FALLBACK = 'bXVydWdhOmFtbhhbW1hYW1tYTEyM2FhMg';
const STAGING_API_URL = 'https://staging-apis.whpaitool.com/api/v1';
const STAGING_SOCKET_URL = 'https://staging-apis.whpaitool.com';
const STAGING_ASSET_ENDPOINT = 'https://whp-test.s3.amazonaws.com';
const PRODUCTION_API_URL = 'https://apis.whpaitool.com/api/v1';
const PRODUCTION_SOCKET_URL = 'https://apis.whpaitool.com';
const PRODUCTION_ASSET_ENDPOINT = 'https://whp-prod-assets.s3.amazonaws.com';

const ENV_FALLBACKS = {
  LOCAL: {
    apiFallback: 'http://127.0.0.1:3000/api/v1',
    socketFallback: 'http://127.0.0.1:3000',
    siteFallback: 'http://127.0.0.1:4000',
    awsEndpointFallback: 'https://whp-local-assets.s3.amazonaws.com',
    aesKeyFallback: '12345678901234567890123456789012',
    aesIvFallback: '1234567890123456',
    landingAuthFallback: LANDING_AUTH_FALLBACK,
  },
  DEV: {
    apiFallback: STAGING_API_URL,
    socketFallback: STAGING_SOCKET_URL,
    landingAuthFallback: LANDING_AUTH_FALLBACK,
  },
  QA: {
    apiFallback: STAGING_API_URL,
    socketFallback: STAGING_SOCKET_URL,
    awsEndpointFallback: STAGING_ASSET_ENDPOINT,
    landingAuthFallback: LANDING_AUTH_FALLBACK,
  },
  STAGING: {
    apiFallback: STAGING_API_URL,
    socketFallback: STAGING_SOCKET_URL,
    awsEndpointFallback: STAGING_ASSET_ENDPOINT,
    landingAuthFallback: LANDING_AUTH_FALLBACK,
  },
  TEST: {
    apiFallback: STAGING_API_URL,
    socketFallback: STAGING_SOCKET_URL,
    landingAuthFallback: LANDING_AUTH_FALLBACK,
  },
  PRODUCTION: {
    apiFallback: PRODUCTION_API_URL,
    socketFallback: PRODUCTION_SOCKET_URL,
    awsEndpointFallback: PRODUCTION_ASSET_ENDPOINT,
    landingAuthFallback: LANDING_AUTH_FALLBACK,
  },
};

const applyBrowserEnvConfig = ({
  apiFallback = '',
  socketFallback = '',
  siteFallback = '',
  awsEndpointFallback = '',
  aesKeyFallback = '',
  aesIvFallback = '',
  landingAuthFallback = '',
} = {}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL || apiFallback;
  const socketUrl = process.env.REACT_APP_SOCKET_URL || socketUrlFromApiUrl(apiUrl) || socketFallback;
  const siteUrl = process.env.REACT_APP_BASE_URL || siteFallback;
  const awsEndpoint = process.env.REACT_APP_AWS_ENDPOINT || trimTrailingSlash(process.env.REACT_APP_S3_URL) || awsEndpointFallback;

  CONFIG.ENV= '';
  CONFIG.API_URL= apiUrl;
  CONFIG.SOCKET_URL= socketUrl;
  CONFIG.SITE_URL= siteUrl;
  CONFIG.AWS_ENDPOINT= awsEndpoint;
  CONFIG.S3_PATH= '';
  CONFIG.ML_TARGET_URL= '';
  CONFIG.TIMEOUT= 10000;
  CONFIG.MINCHAR= 3;
  CONFIG.MAXCHAR= 25;
  CONFIG.CONTENT_LEGNTH= 2000;
  CONFIG.REACT_APP_AES_ENC_SECRET_KEY= process.env.REACT_APP_AES_ENC_SECRET_KEY || aesKeyFallback
  CONFIG.REACT_APP_AES_ENC_IV= process.env.REACT_APP_AES_ENC_IV || aesIvFallback;
  CONFIG.REACT_APP_LANDING_AUTHORIZATION_KEY= process.env.REACT_APP_LANDING_AUTHORIZATION_KEY || landingAuthFallback;
  CONFIG.REACT_APP_SESSION_PREFIX= process.env.REACT_APP_SESSION_PREFIX || "";
  CONFIG.BASE_URL= siteUrl
  CONFIG.USERBACK_TOKEN=process.env.USERBACK_TOKEN || process.env.REACT_APP_USERBACK_TOKEN;
};

if (CURRENT_ENV === 'LOCAL') {
  applyBrowserEnvConfig(ENV_FALLBACKS.LOCAL);
  // CONFIG.SOCKET_URL= 'http://localhost:3000';
}
if (CURRENT_ENV === 'DEV') {
  applyBrowserEnvConfig(ENV_FALLBACKS.DEV);
  // CONFIG.SOCKET_URL= 'http://localhost:3000';
}
else if (CURRENT_ENV === 'QA') {
  applyBrowserEnvConfig(ENV_FALLBACKS.QA);
  // CONFIG.SOCKET_URL= 'http://localhost:3000';
}
else if (CURRENT_ENV === 'STAGING') {
  applyBrowserEnvConfig(ENV_FALLBACKS.STAGING);
  // CONFIG.SOCKET_URL= 'http://localhost:3000';
}
else if (CURRENT_ENV === 'TEST') {
  applyBrowserEnvConfig(ENV_FALLBACKS.TEST);
  // CONFIG.SOCKET_URL= 'http://localhost:3000';
}
else if (CURRENT_ENV === 'PRODUCTION') {
  applyBrowserEnvConfig(ENV_FALLBACKS.PRODUCTION);
  // CONFIG.SOCKET_URL= 'http://localhost:3000';
}
module.exports = CONFIG;
